/* Brick Me for Business - B2B solutions page.
   Two halves, both ported from the Claude Design artboard:
     1. the kinetic scroll engine (was kinetic.js in the design project)
     2. the page controller (was a React component; reimplemented as plain DOM) */
(function () {
  'use strict';

  var INSTANCES = new WeakMap();

  /* =========================================================== scroll engine */

  // Offsets each reveal animation starts from, keyed by the --anim marker the
  // markup carries. Same names the artboard used.
  var FROM = {
    riseIn: 'translateY(42px)',
    slideL: 'translateX(-52px)',
    slideR: 'translateX(52px)',
    popIn: 'scale(0.9)',
    drawX: 'scaleX(0)'
  };

  function Kinetic(root) {
    this.root = root;
    this.par = [];
    this.fills = [];
    this.vids = [];
    this.hero = null;
    this.zoom = null;
    this.cue = null;
    this.bar = null;
    this.lastScan = -1e6;
    this.off = false;
    this.firstPass = true;
  }

  Kinetic.prototype.vh = function () {
    return document.documentElement.clientHeight || window.innerHeight || 700;
  };

  Kinetic.prototype.clamp = function (v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  };

  Kinetic.prototype.reveal = function (n, instant) {
    n.dataset.animDone = '1';
    n.dataset.animPending = '0';
    if (instant) {
      n.style.transition = 'none';
      n.style.opacity = '1';
      n.style.transform = 'none';
      return;
    }
    var d = n.dataset.animStagger || '0';
    n.style.transition =
      'opacity 700ms cubic-bezier(.16,1,.3,1) ' + d + 'ms, transform 820ms cubic-bezier(.16,1,.3,1) ' + d + 'ms';
    n.style.opacity = '1';
    n.style.transform = 'none';
  };

  Kinetic.prototype.scan = function () {
    var nodes = this.root.querySelectorAll('[data-anim]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var name = n.dataset.animName || n.style.getPropertyValue('--anim').trim();
      if (!name || name === 'none') continue;
      n.dataset.animName = name;
      if (name === 'par') { if (this.par.indexOf(n) < 0) this.par.push(n); continue; }
      if (name === 'railFill') { if (this.fills.indexOf(n) < 0) this.fills.push(n); continue; }
      if (name === 'heroOut') { this.hero = n; continue; }
      if (name === 'heroZoom') { this.zoom = n; continue; }
      if (name === 'cueOut') { this.cue = n; continue; }
      if (name === 'progress') { this.bar = n; continue; }
      if (!FROM[name] || n.dataset.animDone === '1') continue;
      if (n.dataset.animPending !== '1') {
        var p = n.parentElement;
        var idx = p.__bmIndex || 0;
        p.__bmIndex = idx + 1;
        n.dataset.animStagger = String(Math.min(idx, 5) * 80);
        n.style.transition = 'none';
        n.style.opacity = name === 'drawX' ? '1' : '0';
        n.style.transform = FROM[name];
        if (name === 'drawX') n.style.transformOrigin = '0 50%';
        n.dataset.animPending = '1';
      }
    }
  };

  Kinetic.prototype.videos = function (h) {
    var found = this.root.querySelectorAll('[data-astro-video]');
    for (var i = 0; i < found.length; i++) if (this.vids.indexOf(found[i]) < 0) this.vids.push(found[i]);
    for (var j = 0; j < this.vids.length; j++) {
      var v = this.vids[j];
      var r = v.getBoundingClientRect();
      var inView = r.bottom > h * 0.12 && r.top < h * 0.88;
      if (inView && v.paused) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!inView && !v.paused) {
        v.pause();
      }
    }
  };

  // The artboard was drawn with no site chrome above it, so the hero was a flat
  // 100vh. On the storefront the promo bars and header sit above it, and the two
  // states differ: at the top of the page the hero starts below ALL the chrome,
  // but once scrolled it pins below the sticky header alone (the promo bars
  // scroll away, and are dismissible). So measure both and let CSS do the maths.
  Kinetic.prototype.chrome = function () {
    var root = this.root;
    var sticky = document.querySelector('sticky-header');
    // reduce-logo-size shrinks the header once stuck, so measure it live
    var stickyH = sticky ? Math.round(sticky.getBoundingClientRect().height) : 0;
    // distance from the viewport top down to the section: all chrome at scroll 0,
    // shrinking to zero as the non-sticky bars scroll out of view
    var above = Math.max(0, Math.round(root.getBoundingClientRect().top));
    var top = Math.max(stickyH, above);
    var h = Math.max(320, Math.round((window.innerHeight || 700) - top));

    if (top !== this._chromeTop) {
      this._chromeTop = top;
      root.style.setProperty('--bm-hero-top', stickyH + 'px');
    }
    if (h !== this._chromeH) {
      this._chromeH = h;
      root.style.setProperty('--bm-hero-h', h + 'px');
    }
  };

  Kinetic.prototype.tick = function () {
    var de = document.documentElement;
    this.chrome();
    var isOff = this.root.getAttribute('data-motion') === 'off';
    if (isOff !== this.off) {
      this.off = isOff;
      if (this.off) {
        var stuck = this.root.querySelectorAll('[data-anim-pending="1"]');
        for (var z = 0; z < stuck.length; z++) this.reveal(stuck[z], true);
        if (this.bar) this.bar.style.transform = 'scaleX(1)';
        for (var q = 0; q < this.fills.length; q++) this.fills[q].style.clipPath = 'none';
      }
    }
    if (this.off) return;

    var now = Date.now();
    var scanned = false;
    if (now - this.lastScan > 250) { this.lastScan = now; this.scan(); scanned = true; }

    var y = de.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
    var h = this.vh();

    if (this.bar) {
      this.bar.style.transform = 'scaleX(' + this.clamp(y / Math.max(1, de.scrollHeight - h)).toFixed(4) + ')';
    }
    if (this.hero) {
      var hp = this.clamp((y - h * 0.08) / (h * 0.5));
      this.hero.style.opacity = String(1 - hp);
      this.hero.style.transform = 'translateY(' + (-80 * hp).toFixed(1) + 'px) scale(' + (1 - 0.05 * hp).toFixed(3) + ')';
    }
    if (this.zoom) {
      var pin = Number(this.root.getAttribute('data-pin') || 168) / 100;
      this.zoom.style.transform = 'scale(' + (1 + 0.18 * this.clamp(y / (h * pin))).toFixed(3) + ')';
    }
    if (this.cue) this.cue.style.opacity = String(1 - this.clamp(y / (h * 0.22)));

    // Deferred one tick past a scan so the hidden state paints first
    if (!scanned) {
      var waiting = this.root.querySelectorAll('[data-anim]');
      var acted = false;
      for (var j = 0; j < waiting.length; j++) {
        var w = waiting[j];
        if (w.dataset.animDone === '1') continue;
        if (w.style.opacity !== '0' && w.dataset.animPending !== '1') continue;
        if (!FROM[w.dataset.animName || w.style.getPropertyValue('--anim').trim()]) continue;
        if (w.getBoundingClientRect().top < h * 0.9) { this.reveal(w, this.firstPass); acted = true; }
      }
      if (acted) this.firstPass = false;
    }

    this.videos(h);

    for (var m = 0; m < this.fills.length; m++) {
      var fr = this.fills[m].getBoundingClientRect();
      var fp = this.clamp((h * 0.8 - fr.top) / (h * 0.42));
      // the rail runs horizontally on desktop and vertically once the steps stack
      var vertical = this.fills[m].offsetHeight > this.fills[m].offsetWidth;
      this.fills[m].style.clipPath = vertical
        ? 'inset(0 0 ' + ((1 - fp) * 100).toFixed(2) + '% 0)'
        : 'inset(0 ' + ((1 - fp) * 100).toFixed(2) + '% 0 0)';
    }

    for (var k = 0; k < this.par.length; k++) {
      var pq = this.par[k];
      var pr = pq.getBoundingClientRect();
      if (pr.bottom < -240 || pr.top > h + 240) continue;
      pq.style.transform = 'translateY(' + (((pr.top + pr.height / 2 - h / 2) / h) * 7).toFixed(2) + '%) scale(1.18)';
    }
  };

  /* ======================================================== page controller */

  function B2B(root) {
    this.root = root;
    this.kinetic = new Kinetic(root);
    this.cases = [];
    this.filter = 'all';
    this.expand = {};
    this.faq = null;
    this.boot();
  }

  B2B.prototype.boot = function () {
    var self = this;

    var data = this.root.querySelector('[data-case-data]');
    if (data) {
      try {
        this.cases = JSON.parse(data.textContent);
      } catch (e) {
        this.cases = [];
      }
    }

    this.wireNav();
    this.wireFilters();
    this.wireCases();
    this.wireFaq();
    this.wireReadMore();
    this.wireForm();

    this.onKey = function (e) {
      if (e.key === 'Escape') self.closeCase();
    };
    document.addEventListener('keydown', this.onKey);

    this.drive = function () {
      self.kinetic.tick();
    };
    this.iv = setInterval(this.drive, 40);
    window.addEventListener('scroll', this.drive, { passive: true });
    window.addEventListener('resize', this.drive);
    this.drive();

    this.revealStatus();
  };

  B2B.prototype.destroy = function () {
    document.removeEventListener('keydown', this.onKey);
    clearInterval(this.iv);
    clearTimeout(this._flashT);
    window.removeEventListener('scroll', this.drive);
    window.removeEventListener('resize', this.drive);
  };

  /* ------------------------------------------------------------ navigation */

  // Every in-page CTA routes through here. Beyond scrolling it can preselect the
  // case filter, prefill the enquiry form's project dropdown, and flash a card -
  // which is how "Ask about a model" lands you on the form already filled in.
  B2B.prototype.jump = function (id, opts) {
    var o = opts || {};
    var el = this.root.querySelector('#' + id);
    if (el) {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' });
    }
    if (o.filter) this.setFilter(o.filter);
    if (o.project) {
      var sel = this.root.querySelector('[data-project-select]');
      if (sel) sel.value = o.project;
    }
    if (o.flash) this.flash(o.flash);
  };

  B2B.prototype.flash = function (id) {
    var el = this.root.querySelector('#' + id);
    if (!el) return;
    // on phones the format cards sit in a horizontal rail, so bring the flashed
    // card into view sideways as well as vertically
    var rail = el.closest('[data-r~="swipe"]');
    if (rail && rail.scrollWidth > rail.clientWidth + 4) {
      rail.scrollTo({ left: Math.max(0, el.offsetLeft - rail.offsetLeft - 4), behavior: 'smooth' });
    }
    if (this._flashEl) this._flashEl.style.boxShadow = this._flashPrev;
    clearTimeout(this._flashT);
    var prev = el.style.boxShadow;
    this._flashEl = el;
    this._flashPrev = prev;
    el.style.transition = 'box-shadow 260ms var(--ease-out)';
    el.style.boxShadow = '0 0 0 3px var(--brand-blue), var(--shadow-card-hover)';
    var self = this;
    this._flashT = setTimeout(function () {
      el.style.boxShadow = prev;
      self._flashEl = null;
    }, 1800);
  };

  var ROUTES = {
    form: {},
    router: {},
    events: { id: 'builds', filter: 'events', project: 'Event or activation', flash: 'card-mass' },
    gifting: { id: 'gifting', filter: 'gifting', project: 'Corporate gifting' },
    team: { id: 'builds', filter: 'team', project: 'Team building', flash: 'card-classic' },
    model: { id: 'models', project: 'Custom brick model' },
    display: { id: 'display', project: 'Wall art or pre-assembled mosaic' },
    logo: { id: 'display', flash: 'card-logokits' },
    formGift: { id: 'form', project: 'Corporate gifting' },
    formModel: { id: 'form', project: 'Custom brick model' },
    formDisplay: { id: 'form', project: 'Wall art or pre-assembled mosaic' },
    formOther: { id: 'form', project: 'School, community or private event' }
  };

  B2B.prototype.wireNav = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-go]') : null;
      if (!t || !self.root.contains(t)) return;
      var key = t.getAttribute('data-go');
      if (key === 'formFromCase') {
        self.closeCase();
        setTimeout(function () { self.jump('form'); }, 60);
        return;
      }
      var r = ROUTES[key];
      if (!r) return;
      self.jump(r.id || key, r);
    });
  };

  /* ----------------------------------------------------------- case studies */

  B2B.prototype.setFilter = function (id) {
    this.filter = id;
    this.root.querySelectorAll('[data-filter]').forEach(function (b) {
      var on = b.getAttribute('data-filter') === id;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.style.border = '1px solid ' + (on ? 'var(--text-body)' : 'var(--border)');
      b.style.background = on ? 'var(--text-body)' : 'var(--surface-card)';
      b.style.color = on ? '#fff' : 'var(--text-muted)';
    });
    this.root.querySelectorAll('[data-case-tile]').forEach(function (t) {
      var show = id === 'all' || t.getAttribute('data-case-filter') === id;
      t.style.display = show ? '' : 'none';
    });
  };

  B2B.prototype.wireFilters = function () {
    var self = this;
    this.root.querySelectorAll('[data-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.setFilter(b.getAttribute('data-filter'));
      });
    });
    this.setFilter('all');
  };

  B2B.prototype.wireCases = function () {
    var self = this;
    this.root.querySelectorAll('[data-case-tile]').forEach(function (t) {
      t.addEventListener('click', function () {
        self.openCase(t.getAttribute('data-case-id'));
      });
    });
    var modal = this.root.querySelector('[data-case-modal]');
    if (!modal) return;
    modal.addEventListener('click', function (e) {
      // backdrop closes; the panel stops the click from reaching it
      if (e.target === modal) self.closeCase();
    });
    this.root.querySelectorAll('[data-case-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.closeCase(); });
    });
    this.root.querySelectorAll('[data-stop-click]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  };

  B2B.prototype.openCase = function (id) {
    var c = null;
    for (var i = 0; i < this.cases.length; i++) if (this.cases[i].id === id) c = this.cases[i];
    var modal = this.root.querySelector('[data-case-modal]');
    if (!c || !modal) return;

    var set = function (sel, text) {
      var el = modal.querySelector(sel);
      if (el) el.textContent = text || '';
    };
    set('[data-case-cat]', c.cat);
    set('[data-case-brand]', c.brand);
    set('[data-case-story]', c.story);

    var shots = modal.querySelector('[data-case-shots]');
    if (shots) {
      shots.innerHTML = '';
      (c.photos || []).forEach(function (u) {
        var d = document.createElement('div');
        d.setAttribute('role', 'img');
        d.setAttribute('aria-label', c.brand + ' brick mosaic project by Brick Me');
        d.style.cssText =
          'width:100%;height:250px;border-radius:16px;background-size:cover;background-position:center;' +
          'background-color:var(--surface-muted);background-image:url("' + u + '")';
        shots.appendChild(d);
      });
    }

    var quoteWrap = modal.querySelector('[data-case-quote-wrap]');
    if (quoteWrap) {
      if (c.quote) {
        quoteWrap.style.display = '';
        set('[data-case-quote]', '“' + c.quote + '”');
        set('[data-case-by]', '- ' + (c.by || ''));
      } else {
        quoteWrap.style.display = 'none';
      }
    }

    // visibility is driven by aria-hidden in CSS: the artboard's own style
    // attribute already carries display:flex, which would beat an inline
    // display:none set here
    modal.setAttribute('aria-hidden', 'false');
    this._scrollLock = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-case-close]');
    if (closeBtn) closeBtn.focus();
  };

  B2B.prototype.closeCase = function () {
    var modal = this.root.querySelector('[data-case-modal]');
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = this._scrollLock || '';
  };

  /* -------------------------------------------------------------------- FAQ */

  B2B.prototype.wireFaq = function () {
    var self = this;
    this.root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = btn.getAttribute('data-faq-toggle');
        self.setFaq(self.faq === k ? null : k);
      });
    });
    this.setFaq(null);
  };

  B2B.prototype.setFaq = function (key) {
    this.faq = key;
    var self = this;
    this.root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      var k = btn.getAttribute('data-faq-toggle');
      var on = k === key;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      var panel = self.root.querySelector('[data-faq-panel="' + k + '"]');
      if (panel) panel.style.display = on ? '' : 'none';
      var spin = btn.querySelector('[data-faq-spin]');
      if (spin) {
        spin.style.color = on ? 'var(--brand-blue)' : 'var(--text-muted)';
        spin.style.transform = on ? 'rotate(180deg)' : 'rotate(0deg)';
        spin.style.transition = 'transform var(--dur-base) var(--ease-out), color var(--dur-base)';
      }
    });
  };

  /* -------------------------------------------------------------- read more */

  // Long paragraphs clamp to a few lines on phones; the toggle only appears
  // there (CSS hides it above 560px).
  B2B.prototype.wireReadMore = function () {
    var self = this;
    this.root.querySelectorAll('[data-more-toggle]').forEach(function (btn) {
      var k = btn.getAttribute('data-more-toggle');
      btn.addEventListener('click', function () {
        var open = !self.expand[k];
        self.expand[k] = open;
        var p = self.root.querySelector('[data-clamp="' + k + '"]');
        if (p) p.setAttribute('data-collapsed', open ? '0' : '1');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    });
  };

  /* ------------------------------------------------------------------- form */

  var REQUIRED = [
    ['name', 'Please add your name.'],
    ['email', 'We need an email to reply to.'],
    ['country', 'Let us know where you are.'],
    ['project', 'Pick the closest match.']
  ];

  B2B.prototype.wireForm = function () {
    var self = this;
    // {% form 'contact' %} only reliably passes id and class through, so the
    // hook is a class rather than a data attribute
    var form = this.root.querySelector('.bm-b2b-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var errors = {};
      var val = function (n) {
        var f = form.querySelector('[data-field="' + n + '"]');
        return f ? String(f.value || '').trim() : '';
      };

      REQUIRED.forEach(function (pair) {
        if (!val(pair[0])) errors[pair[0]] = pair[1];
      });
      var email = val('email');
      if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        errors.email = "That email doesn't look right.";
      }

      var keys = Object.keys(errors);
      self.root.querySelectorAll('[data-err]').forEach(function (s) {
        var k = s.getAttribute('data-err');
        s.textContent = errors[k] || '';
        s.style.display = errors[k] ? '' : 'none';
      });

      if (!keys.length) return; // let Shopify take it
      e.preventDefault();
      var first = form.querySelector('[data-field="' + keys[0] + '"]');
      if (first) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        first.focus();
      }
    });
  };

  // Shopify bounces back to the form anchor, but the kinetic layout settles
  // afterwards - re-aim at the status panel the same way the partnership page does.
  B2B.prototype.revealStatus = function () {
    var panel = this.root.querySelector('[data-b2b-sent], [data-b2b-error]');
    if (!panel) return;
    var interrupted = false;
    var stop = function () { interrupted = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, stop, { passive: true, once: true });
    });
    var settle = function () {
      if (interrupted) return;
      var header = document.querySelector('sticky-header, .shopify-section-header-sticky');
      var offset = (header ? header.offsetHeight : 0) + 24;
      var y = panel.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
    };
    settle();
    requestAnimationFrame(settle);
    setTimeout(settle, 300);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
  };

  /* ------------------------------------------------------------------- boot */

  function mount(scope) {
    (scope || document).querySelectorAll('[data-b2b-root]').forEach(function (root) {
      if (INSTANCES.has(root)) return;
      INSTANCES.set(root, new B2B(root));
    });
  }

  function unmount(scope) {
    (scope || document).querySelectorAll('[data-b2b-root]').forEach(function (root) {
      var inst = INSTANCES.get(root);
      if (!inst) return;
      inst.destroy();
      INSTANCES.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { unmount(e.target); });
})();
